import { patchUnauthorized } from './UnauthorizedApiClient';
import ApiClient from './ApiClient';

const API_BASE_PATH = 'api/tasks';

export default class TaskApi {
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getTasks(opts) {
    return this.apiClient.get({ path: API_BASE_PATH, params: (opts || {}) });
  }

  getAllTasks() {
    return this.apiClient.get({ path: `${API_BASE_PATH}/all` });
  }

  /**
   *
   * @param {{
   *  firstResult?: number;
   *  maxSize?: number;
   *  filterByTaskName?: string;
   *  filterByStartedBy?: string;
   *  filterByDueDate?: string;
   *  filterByCreatedDate?: string;
   *  filterByAssignee?: string;
   *  orderByCreatedDate?: 'desc' | 'asc';
   *  orderByDueDate?: 'desc' | 'asc';
   * }} params
   * @returns
   */
  getAllTasksFiltered(params) {
    return this.apiClient.get({ path: `${API_BASE_PATH}/all`, params });
  }

  assignTask(id, body) {
    return this.apiClient.post({ path: `${API_BASE_PATH}/${id}/identitylinks`, body });
  }

  delegateTask(id, userId) {
    return this.apiClient.post({ path: `${API_BASE_PATH}/${id}/delegate/${userId}` });
  }

  getTaskVariables(id) {
    return this.apiClient.get({ path: `${API_BASE_PATH}/${id}/variables` });
  }

  multiTaskAction(body) {
    return this.apiClient.post({
      path: API_BASE_PATH,
      body,
    });
  }

  getMassActionSettings() {
    return this.apiClient.get({
      path: 'api/mass-task-action/config',
    });
  }

  getMassActionTasks(processDefinitionKey, taskDefinitionKey) {
    return this.apiClient.get({
      path: `api/mass-task-action/tasks/${processDefinitionKey}/${taskDefinitionKey}`,
    });
  }

  massCompleteTasks(ids, outcome, variables) {
    return this.apiClient.post({
      path: 'api/mass-task-action/tasks',
      body: {
        taskIds: ids,
        action: {
          action: 'complete',
          outcome,
          variables,
        },

      },
    });
  }

  completeTask(id, taskData, attachments) {
    const formData = new FormData();
    formData.append('action', JSON.stringify(taskData));
    formData.append('attachments', JSON.stringify(attachments || []));
    return this.apiClient.post({ path: `${API_BASE_PATH}/${id}`, body: formData });
  }

  // eslint-disable-next-line class-methods-use-this
  completeTaskWithTaskActionId(id) {
    return patchUnauthorized({ path: `api/public/tasks/complete/${id}` });
  }

  getNextTask(processInstanceId) {
    return this.apiClient.get(
      { path: `${API_BASE_PATH}/next/${processInstanceId}` },
    );
  }

  getTaskDefaultVariables(body) {
    return this.apiClient.post(
      { path: `${API_BASE_PATH}/defaultvariables`, body },
    );
  }

  getActiveTasks(key) {
    return this.apiClient.get(
      { path: `${API_BASE_PATH}/${encodeURIComponent(key)}/active-tasks` },
    );
  }
}
